module.exports = __webpack_public_path__ + "img/a3.1e926b48.png";